export default __webpack_public_path__ + "static/media/important_notif.e3ca6572.mp3";